import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material";
import ActiveTeams from "_shared/teams/teams-active-page";
import { PageTab } from "_shared/teams/teams-tabs";
import TeamsTemplatesPage from "_shared/teams/teams-templates-page";
import React from "react";
import { useLoaderData, useNavigate } from "react-router-dom";


export const ToolbarButtonsContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  display: "flex",
  alignItems: "end",
  flexDirection: "column",
  gap: theme.spacing(1),
}));
export const ToolbarButtons = styled("div")(() => ({
  display: "flex",
  alignItems: "end",
  flexWrap: "nowrap",
}));
export const TableTopToolbarContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));
export const LowerTopToolbarContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
  display: "flex",
  flexDirection: "row",
  alignItems: "left",
  width: "100%",
}));
export const TableTitle = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
}));
export const RowTitle = styled(Typography)(() => ({
  fontSize: "1.1em",
  fontWeight: "600",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export function TeamsTabs({ activeTab }: Readonly<{ activeTab: PageTab }>) {
  const navigate = useNavigate();
  return (
    <Tabs
      value={activeTab}
      indicatorColor="primary"
      textColor="primary"
      onChange={(_event, newValue) => navigate(`/teams/${newValue}/`)}
    >
      <Tab value={PageTab.Templates} label="Templates" />
      <Tab value={PageTab.TeamsOn} label="Teams I'm On" />
      <Tab value={PageTab.TeamsWorkingForMe} label="Teams Working For Me" />
      <Tab value={PageTab.Archived} label="Archived" />
    </Tabs>
  );
}

export default function Teams() {
  const routeParams = useLoaderData();

  const tab = routeParams?.tab;

  if (tab === PageTab.Templates || tab === PageTab.Archived) {
    return <TeamsTemplatesPage />;
  }

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <ActiveTeams />
    </React.Suspense>
  );
}